import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ErrorDto } from '../../../models/dtos/error.dto';
import { Errors } from '../../errors';
import deleteAccountRequest from './deleteAccount.repository';
import { GenerateOTPDto } from '../../../models/dtos/generateOTP.dto';

type InitialState = {
  loading: boolean;
  data?: GenerateOTPDto;
  error?: ErrorDto;
};
const initialState: InitialState = {
  loading: false,
  data: undefined,
  error: undefined,
};

export const deleteAccount = createAsyncThunk(
  'deleteAccount',
  async (_, { dispatch }) => {
    const response = await deleteAccountRequest();
    return response;
  }
);

const deleteAccountSlice = createSlice({
  name: 'deleteAccount',
  initialState,
  reducers: {
    deleteAccountReset: (state) => {
      state.loading = false;
      state.data = undefined;
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(deleteAccount.pending, (state) => {
      state.loading = true;
      state.data = undefined;
      state.error = undefined;
    });
    builder.addCase(
      deleteAccount.fulfilled,
      (state, action: PayloadAction<GenerateOTPDto>) => {
        state.loading = false;
        state.data = action.payload;
      }
    );
    builder.addCase(deleteAccount.rejected, (state, action) => {
      state.loading = false;
      state.error = Errors.getErrorDtoFromApiError(action.error);
    });
  },
});

export default deleteAccountSlice.reducer;
export const { deleteAccountReset } = deleteAccountSlice.actions;
